import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import OpportunityActivityList from "modules/activities/OpportunityActivityList/OpportunityActivityList";
import { CustomGetOpportunityQuery } from "generated/graphql";
type OpportunityForUpdate = NonNullable<CustomGetOpportunityQuery["getOpportunity"]>;

export default function OpportunityActivityPanel({
  opportunity,
}: {
  opportunity: OpportunityForUpdate;
}) {
  const contactId = (opportunity as any)?.contactId ?? (opportunity as any)?.contact?.id ?? null;
  const companyId = (opportunity as any)?.companyId ?? (opportunity as any)?.company?.id ?? null;
  const opportunityId = (opportunity as any)?.id ?? null;
  const opportunityDisplayId = (opportunity as any)?.externalId ?? opportunityId;
  const opportunityLabel = `Opportunity #${String(opportunityDisplayId)}`;

  return (
    <Card>
      <MDBox>
        <OpportunityActivityList
          contactId={contactId}
          companyId={companyId}
          opportunityId={opportunityId}
          opportunityLabel={opportunityLabel}
        />
      </MDBox>
    </Card>
  );
}
